import { useMemo } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import { getCqsMetrics } from '../../components/widgets/RiskProducts/CqsChart/CqsChart.logic';
import { getCreMetrics } from '../../components/widgets/RiskProducts/CreChart/CreChart.logic';
import { RiskMetrics, RiskProductsData } from '../../models/RiskProducts';
import { fetchCompanyChart } from '../../services/riskProducts/riskProducts.service';
import { queryKeys } from '../queryKeyFactory';

interface UseFetchRiskProductResult {
  data: RiskMetrics;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export default (companyId: string, options?: UseQueryOptions<RiskProductsData, Error>): UseFetchRiskProductResult => {
  const query = useQuery<RiskProductsData, Error>(
    queryKeys.fetchRiskProducts.chartByCompany(companyId),
    async () => fetchCompanyChart(companyId),
    options
  );

  const { data: riskProducts, isLoading, isSuccess, isError, refetch } = query;

  const data = useMemo(() => {
    return {
      cqsMetrics: isSuccess ? getCqsMetrics(riskProducts) : [],
      creMetrics: isSuccess ? getCreMetrics(riskProducts) : [],
      modelId: isSuccess ? riskProducts?.model_id : '',
      regionId: isSuccess ? riskProducts?.region_id : '',
    };
  }, [isSuccess, riskProducts]);

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};
